import * as React from "react";
import { useAccount } from "../../Account";
import { Box, Toolbar } from "@mui/material";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import AccountGuardianSelector from "./AccountGuardianSelector";
import { useCallback } from "react";
import { useScrollToTop } from "@tlc/ui/ScrollToTop";

export const AccountLoansPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { hasChildrenAndCanViewDependentLoansActivity } = useAccount();

  const [scrollCallbackRef, scrollToTop] = useScrollToTop();

  const handleSelectId = useCallback(
    (id?: string | null): void => {
      const path = id ? `/myaccount/loans/child/${id}` : `/myaccount/loans`;
      navigate(path);
    },
    [navigate],
  );

  return (
    <>
      <Box component="div" ref={scrollCallbackRef} tabIndex={-1} />
      {hasChildrenAndCanViewDependentLoansActivity && (
        <Box component="div" sx={{ p: 1 }}>
          <AccountGuardianSelector selectedId={id} onSelect={handleSelectId} />
        </Box>
      )}
      <Outlet context={{ scrollToTop }} />
    </>
  );
};
